import React, { useState, useRef, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Image } from 'react-bootstrap';
import contactImg from '../images/contact/new.jpg';
import phone from '../images/contact/phone.png';
import email from '../images/contact/email.png';
import gps from '../images/contact/gps.png';
import emailjs from '@emailjs/browser';

import '../styles/contact.css';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
        phone: '',
       
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const form = useRef();

    useEffect(() => {
        emailjs.init(''); // Initialize EmailJS with your public key
    }, []); // Empty dependency array ensures it runs only once on component mount

    const handleSubmit = (e) => {
        e.preventDefault();

        emailjs.sendForm(
            process.env.REACT_APP_EMAILJS_SERVICE_ID,  // Service ID
            process.env.REACT_APP_EMAILJS_TEMPLATE_ID, // Template ID
            form.current,
            process.env.REACT_APP_EMAILJS_PUBLIC_KEY // Public Key
        )
            .then((result) => {
                alert('Tesekkurler ' + formData.name + ' 😊 ' + '!');
                // Smooth scroll to the top of the page
                window.scrollTo(0, 0)
            }, (error) => {
                alert(error.text);
            });

        setFormData({ name: '', email: '', subject: '', message: '', phone: '' });
    };

    return (
        <div className="contact-container">
            <Image src={contactImg} fluid className='contact-img' />
            <Container className='container-form'>
                <Row className='mt-4 justify-content-md-center'>
                <Col md={6} >
                <h1 className='contact-header'>İletişim Bilgileri</h1>
                <hr/>
                <p>Uzm. Dr. Birsen Ergus Dermatoloji Uzmanı</p>
                        <ul className='contact-locations'>
                            <div className='contact-element'>

                                <div className='iconBg'>
                                    <img src={gps} className='contactIcon' alt='gps' />
                                </div>
                                <li>

                                    <h1>Adres</h1>
                                    <p>
                                    Efe Plaza İş Merkezi Akpınar Mahallesi 
                                    </p>
                                    <p>367. Sokak No:2/54 Osmangazi/Bursa</p>
                                </li>
                            </div>

                           

                            <div className='contact-element'>
                                <div className='iconBg'>
                                    <img src={email} className='contactIcon' alt='Facebook' />
                                </div>
                                <li>
                                    <h1>Bize Ulaşın</h1>
                                    <p>birsen@birsenergus.com</p>
                                    <p>birsenergus@yahoo.com</p>
                                </li>
                            </div>

                            <div className='contact-element'>
                                <div className='iconBg'>
                                    <img src={phone} className='contactIcon' alt='Facebook' />
                                </div>
                                <li>
                                    <h1 >Bizi Arayın</h1>
                                    <p><a href="tel:+905300449565"> 0 (530) 044 95 65</a></p>
                                </li>
                            </div>

                        </ul>


                    </Col>
                    <Col md={6}>
                        <h1 className='contact-header'>İletişim Formu</h1>
                        <hr/>
                        <Form ref={form} onSubmit={handleSubmit}>
                            <Form.Group as={Row}>
                                <Col sm={6}>
                                    <Form.Control
                                        type="text"
                                        placeholder="Ad Soyad"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />
                                </Col>
                                <Col sm={6}>
                                    <Form.Control
                                        type="email"
                                        placeholder="E-mail"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />
                                </Col>
                            </Form.Group>


                            <Form.Group as={Row}>
                                <Col sm={6}>
                                    <Form.Control
                                        type="text"
                                        placeholder="05XX XXX XXXX"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                    />
                                </Col>
                                <Col sm={6}>
                                    <Form.Control
                                        type="text"
                                        placeholder="Konu"
                                        name="subject"
                                        value={formData.subject}
                                        onChange={handleChange}
                                        required
                                    />
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">

                                <Col sm={12}>
                                    <Form.Control
                                        as="textarea"
                                        rows={5}
                                        maxRows={10}
                                        placeholder="Mesaj"
                                        name="message"
                                        value={formData.message}
                                        onChange={handleChange}
                                        required
                                    />
                                </Col>
                            </Form.Group>

                            <Button variant="primary" type="submit" className="bg-black text-white">
                                Gönder
                            </Button>
                        </Form>
                    </Col>
                   
                </Row>
            </Container>
        </div>
    );
}

export default Contact;
